
export const NOMINA_ACTIVE = process.env.REACT_APP_NOMINA_ACTIVE === "TRUE";
export const PABS_ACTIVE = process.env.REACT_APP_PABS_ACTIVE === "FALSE";
export const PERSONAL_ACTIVE = process.env.REACT_APP_PERSONAL_ACTIVE === "FALSE";
export const API_URL = process.env.REACT_APP_API_URL ?? "https://dev.percapita.mx/api";